import api from './api';

function authHeaders() {
	const token = localStorage.getItem('companyToken');
	return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function uploadResumes(files = []) {
	const form = new FormData();
	files.forEach((f) => form.append('resumes', f));
	const res = await api.post('/company/resumes/upload', form, {
		headers: { ...authHeaders(), 'Content-Type': 'multipart/form-data' }
	});
	return res.data;
}

export async function getCompanyResumes(params = {}) {
	const res = await api.get('/company/resumes', { params, headers: authHeaders() });
	return res.data;
}

export async function getCandidateDetails(resumeId) {
	const res = await api.get(`/company/resumes/${resumeId}`, { headers: authHeaders() });
	return res.data;
}

export async function matchCandidates(jobId) {
	const res = await api.post('/company/resumes/match', { jobId }, { headers: authHeaders() });
	return res.data;
}

export async function updateCandidateStatus(resumeId, status) {
	const res = await api.put(`/company/resumes/${resumeId}/status`, { status }, { headers: authHeaders() });
	return res.data;
}


